
import './LegendItem.scss'
const LegendItem = (
    {label,src,width = "35px", heigth = "40px"}) => {
    return (
    <div className='legendItem' style={{display:"flex",flexDirection:"row", alignItems:"center"}}>
        <p style={{marginRight:"3px",whiteSpace: "nowrap" }}>{label}</p>
        <img src={src} alt={label} width={width ?? "35px"} height={heigth ?? "40px"}></img>
               
    </div>
    )
}


export default LegendItem